import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import _uniqueId from 'lodash/uniqueId';
import { Modal, Popover, Tooltip } from 'bootstrap';

import { httpGet } from '../../helpers/httpHelper';
import BiTooltip from './BiTooltip';
import { SessionContext } from '../../../context/SessionProvider';

const BiHelp = ({ grid, helpKey, helpMainKey }) => {

    const { helpMainKey: hmk, sessionData, modalData, setModalData } = useContext(SessionContext)

  //  const [modal, setModal] = useState([]);


    const getKey = () => {
        if (helpMainKey == null) {
            return hmk + "/" + helpKey;
        } else {
            return helpMainKey + "/" + helpKey;
        }
    }

    const showModal = () => {

        if (sessionData.admin == true) {

            if (helpMainKey == null && hmk == null) {
                alert("Nastaviti je potrebno helpMainKey v glavnem oknu!");
                return;
            }

            if (grid == true && helpMainKey == null) {
                alert("Nastaviti je potrebno helpMainKey v gridu!");
                return;
            }

            httpGet("etm/getMoHelp", { key: getKey() }, (data) => {



                const modalEle = modalData.ref.current
                const bsModal = new Modal(modalEle, {
                    backdrop: 'static',
                    keyboard: false
                })

                if (data.data != null) {
                    setModalData(prev => ({ ...prev, desc: data.data.opis, title: "Urejanje pomoči: " + getKey(), onClose: closeModal, modal: bsModal }));
                } else {
                    setModalData(prev => ({ ...prev, desc: null, title: "Urejanje pomoči: " + getKey(), onClose: closeModal, modal: bsModal }));
                }
                console.log(bsModal);
                bsModal.show();
            });
        }

    }

    const closeModal = () => {

        // get modal
        const modal = modalData.ref.current

        const ed = modal.getElementsByClassName("ql-editor")[0].innerHTML;


        let formData = new FormData();
        formData.append('key', getKey());
        formData.append('desc', ed.replaceAll("<p>", "").replaceAll("</p>", "<br>"));

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        fetch(window.getSessionURL("ETM/SetMOHelp"), requestOptions)
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (!data.success) {
                    alert(data.message);
                }

                // change state like in hidden modal
                modal.classList.remove('show');
                modal.setAttribute('aria-hidden', 'true');
                modal.setAttribute('style', 'display: none');

                // get modal backdrops
                const modalsBackdrops = document.getElementsByClassName('modal-backdrop');

                // remove every modal backdrop
                for (let i = 0; i < modalsBackdrops.length; i++) {
                    document.body.removeChild(modalsBackdrops[i]);
                }

            });

    }

    return (
        <Fragment>
            {((hmk != null && grid != true) || (helpMainKey != null && grid == true)) &&
                <div className={grid == true ? "biDataGridHelp" : "biControlInline"}>
                    <BiTooltip helpKey={getKey}>
                        <i onDoubleClick={showModal} className={"fas fa-info-circle biHelpIcon" + (grid == true ? " biHelpIconDG" : "")}></i>
                    </BiTooltip>
                </div>
            }




        </Fragment>
    );
}

export default BiHelp;